// ** React Imports
import { useCallback } from 'react'
import { useRouter } from 'next/router'

// ** Child Imports
import { FormControl } from '@material-ui/core'
import { React } from 'mdi-material-ui'
import GoogleAds from './integrations/GoogleAds'
import GoogleAnalytics from './integrations/GoogleAnalytics'
import Clevertap from './integrations/Clevertap'
import Klaviyo from './integrations/Klaviyo'
import Omnisend from './integrations/Omnisend'
import AiSensy from './integrations/AiSensy'
import Ycloud from './integrations/Ycloud'
import Moengage from './integrations/Moengage'
import Webengage from './integrations/Webengage'
import Contlo from './integrations/Contlo'
import Limechat from './integrations/Limechat'
import FacebookAnalytics from './integrations/Facebook'
import ACRWebhooks from './integrations/Webhooks'
import ShipRocket from './integrations/ShipRocket'
import ClickPost from './integrations/ClickPost'
import PopCoins from './integrations/PopCoins'
import Yotpo from './integrations/Yotpo'
import Retenzy from './integrations/Retenzy'
import Nector from './integrations/Nector'
import YourToken from './integrations/YourToken'
import Flits from './integrations/Flits'
import Casa from './integrations/Casa'
import RewardRally from './integrations/RewardRally'
import ERewards from './integrations/ERewards'
import IthinkLogistics from './integrations/IthinkLogistics'
import GoogleTagManager from './integrations/GoogleTagManager'
import GenericShippingProvider from './integrations/GenericShippingProvider'
import DriveMetadata from './integrations/DriveMetadata'
import { AdditionalScript } from './integrations/AdditionalScript'
import { integrationsConfigType } from 'src/assets/SettingsConfig'

// interface IntegrationAppsProps {}

const IntegrationApps: React.FC<{}> = ({}) => {
  const router = useRouter()
  const { s_id } = router.query

  const renderForms = useCallback(() => {
    return (
      <FormControl style={{ width: '100%' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 16
          }}
        >
          {/* Google Analytics */}
          {s_id === 'ga' && <GoogleAnalytics />}
          {/* Google Ads Converions */}
          {s_id === 'google_ad' && <GoogleAds />}
          {s_id === 'gtm' && <GoogleTagManager />}
          {s_id === 'moengage' && <Moengage />}
          {s_id === 'clevertap' && <Clevertap />}
          {s_id === 'klaviyo' && <Klaviyo />}
          {s_id === 'omnisend' && <Omnisend />}
          {s_id === 'aisensy' && <AiSensy />}
          {s_id === 'ycloud' && <Ycloud />}
          {/* Web Engage Analytics */}
          {s_id === 'webengage' && <Webengage />}
          {s_id === 'contlo' && <Contlo />}

          {/* FB Analytics and Conversion */}
          {s_id === 'facebook' && <FacebookAnalytics />}

          {/* Webhooks Tracking */}
          {s_id === 'webhooks' && <ACRWebhooks />}

          {/* Limechat */}
          {s_id === 'limechat' && <Limechat />}

          {s_id === 'SHIP_ROCKET' && <ShipRocket />}
          {s_id === 'CLICKPOST' && <ClickPost />}
          {s_id === 'ITHINK_LOGISTICS' && <IthinkLogistics />}
          {s_id === integrationsConfigType.ADDITIONAL_SCRIPTS && <AdditionalScript />}
          {s_id === integrationsConfigType.DRIVEMETADATA && <DriveMetadata />}
          {s_id === 'POP_COINS' && <PopCoins />}
          {s_id === 'YOTPO' && <Yotpo />}
          {s_id === 'RETENZY' && <Retenzy />}
          {s_id === 'NECTOR' && <Nector />}
          {s_id === 'YOUR_TOKEN' && <YourToken />}
          {s_id === 'FLITS' && <Flits />}
          {s_id === 'CASA' && <Casa />}
          {s_id === 'REWARD_RALLY' && <RewardRally />}
          {s_id === 'E_REWARDS' && <ERewards />}
          {s_id === 'DELHIVERY' && <GenericShippingProvider provider='DELHIVERY' />}
          {s_id === 'SHIP_DELIGHT' && <GenericShippingProvider provider='SHIP_DELIGHT' />}
          {s_id === 'PRO_SHIP' && <GenericShippingProvider provider='PRO_SHIP' />}
          {s_id === 'EASY_ECOM_CLICK_POST' && <GenericShippingProvider provider='EASY_ECOM_CLICK_POST' />}
        </div>
      </FormControl>
    )
  }, [s_id])

  return <>{renderForms()}</>
}

export default IntegrationApps
